import { bottleIDRegex } from './constants'

export class BottleIDParser {
  constructor(private input: string) {}

  get bottleID() {
    let match: RegExpExecArray | null = null
    let bottleID: string | undefined

    const regex = new RegExp(bottleIDRegex.source, bottleIDRegex.flags)
    while ((match = regex.exec(this.input))) {
      bottleID =
        bottleID ??
        match!.groups?.bottleID ??
        match!.groups?.reducedBottleID ??
        match!.groups.bottleIDShort ??
        match!.groups.bottleIDLong ??
        undefined

      if (bottleID) break
    }

    return bottleID
  }

  get encryptedBottleID() {
    let match: RegExpExecArray | null = null
    let encryptedID: string | undefined

    const regex = new RegExp(bottleIDRegex.source, bottleIDRegex.flags)
    while ((match = regex.exec(this.input))) {
      encryptedID =
        encryptedID ??
        match!.groups?.encryptedID ??
        match!.groups?.reducedEncryptedID ??
        undefined

      if (encryptedID) break
    }

    return encryptedID
  }

  isMatch() {
    const regex = new RegExp(bottleIDRegex.source, bottleIDRegex.flags)
    return regex.test(this.input)
  }
}
